import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrl: './skeleton.component.scss',
    standalone: false
})
export class SkeletonComponent {
  @Input() count: number = 1;
  @Input() height: number = 0;
  @Input() margin: number = 0;
  @Input() borderRadius: string = '';
  @Input() appearance: string = '';
}
